const BASE_URL = process.env.REACT_APP_API_ENDPOINT;
const CommonURL = {
	BASE_URL
};

export default CommonURL;
